import api, { API } from "@/lib/api";

function pad(n) { return String(n).padStart(2, "0"); }

// Single-event "Add to Google Calendar" template URL (uses IST local times).
export function googleEventUrl(appt) {
  const start = `${appt.date.replace(/-/g, "")}T${appt.time.replace(":", "")}00`;
  const [h, m] = appt.time.split(":").map(Number);
  const end = new Date(2000, 0, 1, h, m + 30);
  const endStr = `${appt.date.replace(/-/g, "")}T${pad(end.getHours())}${pad(end.getMinutes())}00`;
  const who = appt.doctor_name || appt.patient_name || "";
  const title = `2nd Opinion — ${appt.specialty} (${who})`;
  const details = `${appt.consult_type}\nWith ${who}\nRef: ${appt.id}`;
  const loc = (appt.consult_type || "").toLowerCase().includes("video") ? "Online video consultation" : "Written second opinion";
  const p = new URLSearchParams({ action: "TEMPLATE", text: title, dates: `${start}/${endStr}`, ctz: "Asia/Kolkata", details, location: loc });
  return `https://calendar.google.com/calendar/render?${p.toString()}`;
}

// Download the appointment as an .ics (Apple Calendar / Outlook / any CalDAV client).
export async function downloadIcs(apptId) {
  const res = await api.get(`/calendar/event/${apptId}.ics`, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url; a.download = `appointment-${apptId}.ics`; a.click();
}

export async function getCalendarFeed() {
  const { data } = await api.get("/calendar/me");
  return data;
}

export { API };
